import React, { memo, useEffect, useState } from 'react';
import cn from 'classnames';
import { IBaseSection, IContent } from 'src/interface';
import { Element, Section } from 'src/components';
import TitleWrap from 'src/modules/shared/components/TitleWrap';
import { useTracking } from 'src/hooks/useTracking';
import { ContentList } from 'src/modules/content/components/list';
import { SECTION_ID } from 'src/constants';

interface IProps extends IBaseSection<IContent> {
    ContentItemComponent?: React.FunctionComponent<any>;
}

export function ContentTopicType3Section(props: IProps) {
    const {
        items = [],
        title = '',
        link = '',
        id,
        className = cn(
            'topic-section',
            'relative',
            'overflow-hidden',
            'mt-[24px] mb-[20px] p-[16px_20px_20px]',
            'ml-[-20px]',
            'w-[calc(100%+40px)]',
        ),
        displayTimeIn,
        position,
        tracking = `|type_03|${position}|${id}`,
    } = props;

    const trackingRef = useTracking(id, `imps_type_03|${position}`, {
        threshold: 0.5,
    });

    const [thumbBg, setThumbBg] = useState<string>('');

    useEffect(() => {
        const item = items[Math.floor(Math.random() * items.length)];
        setThumbBg(item?.thumb);
    }, []);

    if (!items.length) {
        return null;
    }

    return (
        <Section className={className} domRef={trackingRef}>
            <Element className="absolute inset-0 z-[-1]">
                <Element
                    style={{
                        backgroundImage: `url('${thumbBg}')`,
                    }}
                    className={cn(
                        'absolute inset-0',
                        'blur-[24px]',
                        'bg-center bg-no-repeat bg-cover',
                    )}
                ></Element>
                <Element
                    className={cn(
                        'absolute inset-0',
                        'bg-gradient-to-b from-[rgba(0,0,0,0.6)] to-[rgba(0,0,0,0.8)]',
                    )}
                ></Element>
            </Element>
            <TitleWrap
                title={title?.indexOf('#') > -1 ? title.slice(1) : title}
                link={link}
                renderAs="h2"
                data-text={`${title}`}
                className={cn(
                    'relative',
                    'text-[24px]',
                    'leading-[1.25]',
                    'font-[900]',
                    'uppercase',
                    'text-white',
                    'mb-[16px]',
                )}
                classNameLink={cn(
                    "before:content-['#']",
                    'before:inline-block',
                )}
            />
            <ContentList
                sectionId={`${SECTION_ID.CONTENT_BY_TOPIC}`}
                items={items.slice(0, 3)}
                tracking={tracking}
                displayTimeIn={displayTimeIn}
                hasLayoutPhoto={false}
                ContentItemProps={{ lazyloadImage: false }}
                ContentItemClass={{
                    CardClass: '!border-[rgba(255,255,255,0.2)]',
                    CardHeaderClass: 'text-white',
                    CardFooterClass: 'text-[#e5e5e5]'
                }}
            />
        </Section>
    );
}

export default memo(ContentTopicType3Section);
